import React from 'react';

export default ({ url, ...props }) => <a href={url} {...props} />;
